// @ts-ignore
import { firebaseConfig as bundledFirebaseConfig } from '../firebase-messaging-sw.js';
import { BaseUrlDataManagement } from './api-module/services/globalPath';

// Each client has its own Firebase project. Instead of building the frontend once per client, the
// backend tells the app which project to use (FirebaseConfig/Web, picked from its EnvironmentName).
// The config bundled in firebase-messaging-sw.js is only the fallback when the backend can't be reached.

const FIREBASE_CONFIG_URL = BaseUrlDataManagement + 'FirebaseConfig/Web';
const LOAD_TIMEOUT_MS = 5000;

let runtimeFirebaseConfig: any = null;

// Called in main.ts before bootstrap, so the Firebase options are known when AngularFire starts.
export function loadFirebaseConfig(): Promise<void> {
  const request = fetch(FIREBASE_CONFIG_URL)
    .then(response => (response.ok ? response.json() : null))
    .then(config => {
      if (config && config.projectId) {
        runtimeFirebaseConfig = config;
      }
    })
    .catch(() => { /* keep the bundled config */ });
  const timeout = new Promise<void>(resolve => setTimeout(resolve, LOAD_TIMEOUT_MS));
  return Promise.race([request, timeout]).then(() => {
    // console.info, not console.log: main.ts silences console.log in production builds.
    console.info(`[Firebase] projectId: ${getFirebaseOptions().projectId}` +
      (runtimeFirebaseConfig ? ' (from backend)' : ' (bundled fallback)'));
  });
}

export function getFirebaseOptions(): any {
  return runtimeFirebaseConfig || bundledFirebaseConfig;
}

// The service worker is a static file, so it gets the same Firebase config through its URL
// (firebase-messaging-sw.js reads the "config" query parameter).
export function registerFirebaseServiceWorker(): Promise<ServiceWorkerRegistration> {
  if (!('serviceWorker' in navigator)) {
    return Promise.reject(new Error('Service workers are not supported by this browser.'));
  }
  const config = encodeURIComponent(JSON.stringify(getFirebaseOptions()));
  return navigator.serviceWorker.register(`firebase-messaging-sw.js?config=${config}`, {
    scope: 'firebase-cloud-messaging-push-scope'
  });
}
